// Neww
// Добавляем обработчик для чекбоксов
function initCheckboxes() {
    const checkboxes = document.querySelectorAll('.Checkbox__input');

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            const item = this.closest('.Product-description__molding-item');
            const input = item.querySelector('.Counter__input');

            if (this.checked) {
                // Если чекбокс отмечен, устанавливаем значение 1
                input.value = '1';
            } else {
                // Если чекбокс снят, устанавливаем значение 0
                input.value = '0';
            }

            // Используем существующую функцию sum для пересчета
            sum(input, input.value);
        });
    });
}

// Существующий код подсчета суммы для отдельного товара
function sum(btn, value) {
    const PARENT = btn.closest('.Product-description__molding-item-content-price-counter');
    const finalPrice = PARENT.querySelector('.Product-description__molding-item-price-text-total');
    const price = PARENT.querySelector('.Product-description__molding-item-price-text').innerHTML / 1;

    finalPrice.innerHTML = value * price;

    finalSum(btn);
}

// Существующий код увеличения количества
function increment(btn) {
    const input = btn.closest('div').querySelector('input');
    const checkbox = btn.closest('li').querySelector('.Checkbox__input');
    const max = btn.closest('div').querySelector('[data-max]');
    const value = parseInt(input.value);

    if (max && input.value / 1 >= max.getAttribute('data-max') / 1) {
        // Достигнут максимум
    } else if (input.value < 999) {
        input.value = value + 1;
    }
    sum(btn, input.value / 1);
    checkbox.checked = true;
}

// Существующий код уменьшения количества
function decrement(btn) {
    const input = btn.closest('div').querySelector('input');
    const checkbox = btn.closest('li').querySelector('.Checkbox__input');

    if (input.value > 0) input.value = input.value / 1 - 1;
    sum(btn, input.value / 1);
    if (input.value < 1) checkbox.checked = false;
}

// Существующий код обработки ввода
function inputEnter() {
    const PARENT = document.querySelector('.Product-description__pick-molding');
    if (!PARENT) return;
    const inputs = document.querySelectorAll('.Counter__input--js');

    inputs.forEach(input => {
        input.addEventListener('input', () => {
            if (input.value > 999) input.value = 999;
            if (input.value < 0) input.value = 0;

            // Max
            const max = input.closest('div').querySelector('[data-max]');
            if (max && input.value >= max.getAttribute('data-max') / 1) {
                input.value = max.getAttribute('data-max') / 1;
            }

            // Подсчет суммы
            sum(input, input.value / 1);

            // Checked
            const checkbox = input.closest('li').querySelector('.Checkbox__input');
            input.value > 0 ? (checkbox.checked = true) : (checkbox.checked = false);
        });
    });
}

// Существующий код подсчета общей суммы
function finalSum(btn) {
    const PARENT = btn.closest('.Product-description__molding-select');
    const totalPrice = PARENT.querySelector('.Product-description__molding-select-total-price');
    const prices = PARENT.querySelectorAll('.Product-description__molding-item-price-text-total');
    const storage = [];

    prices.forEach(price => {
        storage.push(price.innerHTML / 1);
    });

    const sum = storage.reduce(function(currentSum, currentNumber) {
        return currentSum + currentNumber;
    }, 0);

    totalPrice.innerHTML = sum;
}

// Инициализация
document.addEventListener('DOMContentLoaded', () => {
    inputEnter();
    initCheckboxes();
});

// Old

// function cardCounter() {
// 	var url = window.location.href
// 	// Вставил url prod tandoor (!!! На локалке не сработает !!!)
// 	// if (url.indexOf('/catalog/product/') != -1) {
// 	if (document.querySelector('.Product-description__molding-list') != null) {
// 		let firstList = document.querySelector('.Product-description__molding-list')
// 		let firstListItems = firstList.querySelectorAll('.Product-description__molding-item')

// 		let a = 1

// 		let finalPrice = document.querySelector('.Product-description__molding-select-total-price')
// 		let listItem = document.querySelectorAll('.Product-description__molding-item')
// 		let counterCont = document.querySelector('.Counter__content')
// 		let buttonCountDec = counterCont.querySelector('button[data-decrement]')
// 		let buttonCountInc = counterCont.querySelector('button[data-increment]')
// 		let inputFieldTopCounter = counterCont.querySelector('.Counter__input')

// 		buttonCountDec.onclick = () => {
// 			let storage = 0
// 			if (listItem[0].getAttribute('data-quantity') / 1 <= 0) {
// 				listItem[0].setAttribute('data-selected', false)
// 				listItem[0].classList.add('Product-description__molding-item--disabled')
// 				listItem[0].querySelector('.Checkbox__input').removeAttribute('checked')
// 				listItem[0].querySelector('.Counter__input').value = 0
// 				inputFieldTopCounter.value = 0
// 			} else {
// 				listItem[0].setAttribute('data-selected', true)
// 				listItem[0].classList.remove('Product-description__molding-item--disabled')
// 				listItem[0].querySelector('.Checkbox__input').setAttribute('checked', '')

// 				listItem[0].setAttribute('data-quantity', listItem[0].getAttribute('data-quantity') / 1 - 1)
// 				listItem[0].querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
// 				document.querySelector('.Counter__block-input').querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
// 				listItem[0].setAttribute(
// 					'data-product-summary',
// 					(listItem[0].querySelector('.Product-description__molding-item-price-text').textContent * listItem[0].querySelector('.Counter__input').value) / 1,
// 				)
// 				listItem[0].querySelector('.Product-description__molding-item-price-text-total').textContent = listItem[0].getAttribute('data-product-summary') / 1
// 				storage += listItem[0].getAttribute('data-product-summary') / 1
// 				finalPrice.textContent = storage
// 				document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
// 			}
// 		}

// 		inputFieldTopCounter.oninput = () => {
// 			let storage = 0
// 			listItem[0].setAttribute('data-quantity', inputFieldTopCounter.value)
// 			if (inputFieldTopCounter.value > 0) {
// 				listItem[0].setAttribute('data-selected', true)
// 				listItem[0].classList.remove('Product-description__molding-item--disabled')
// 				listItem[0].querySelector('.Checkbox__input').setAttribute('checked', '')

// 				listItem[0].querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
// 				document.querySelector('.Counter__block-input').querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
// 				listItem[0].setAttribute(
// 					'data-product-summary',
// 					(listItem[0].querySelector('.Product-description__molding-item-price-text').textContent * listItem[0].querySelector('.Counter__input').value) / 1,
// 				)
// 				listItem[0].querySelector('.Product-description__molding-item-price-text-total').textContent = listItem[0].getAttribute('data-product-summary') / 1
// 				storage += listItem[0].getAttribute('data-product-summary') / 1
// 				finalPrice.textContent = storage
// 				document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
// 			} else {
// 				listItem[0].setAttribute('data-selected', false)
// 				listItem[0].classList.add('Product-description__molding-item--disabled')
// 				listItem[0].querySelector('.Checkbox__input').removeAttribute('checked')
// 				listItem[0].querySelector('.Counter__input').value = 0
// 				inputFieldTopCounter.value = 0
// 			}


// 		}

// 		buttonCountInc.onclick = () => {
// 			let storage = 0
// 			listItem[0].setAttribute('data-selected', true)
// 			listItem[0].setAttribute('data-quantity', listItem[0].getAttribute('data-quantity') / 1 + 1)
// 			listItem[0].querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
// 			document.querySelector('.Counter__block-input').querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
// 			listItem[0].setAttribute(
// 				'data-product-summary',
// 				(listItem[0].querySelector('.Product-description__molding-item-price-text').textContent * listItem[0].querySelector('.Counter__input').value) / 1,
// 			)
// 			listItem[0].querySelector('.Product-description__molding-item-price-text-total').textContent = listItem[0].getAttribute('data-product-summary') / 1
// 			storage += listItem[0].getAttribute('data-product-summary') / 1
// 			finalPrice.textContent = storage
// 			document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
// 		}

// 		listItem.forEach((el, id) => {
// 			let buttonDec = el.querySelector('button[data-decrement]')
// 			let buttonInc = el.querySelector('button[data-increment]')
// 			let inputField = el.querySelector('.Counter__input')

// 			// buttonDec.setAttribute('disabled', '')
// 			// buttonInc.setAttribute('disabled', '')
// 			// el.querySelector('.Counter__input').setAttribute('disabled', '')
// 			el.classList.add('Product-description__molding-item--disabled')

// 			document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', 0)

// 			el.querySelector('.Checkbox__inner-text').onclick = () => {
// 				if (el.classList.contains('Product-description__molding-item--disabled')) {
// 					el.classList.toggle('Product-description__molding-item--disabled')
// 				} else {
// 					el.classList.toggle('Product-description__molding-item--disabled')
// 				}
// 				// buttonDec.toggleAttribute('disabled')
// 				// buttonInc.toggleAttribute('disabled')
// 				// el.querySelector('.Counter__input').toggleAttribute('disabled')
// 				let storage = 0
// 				let storage1 = 0
// 				el.setAttribute('data-product-summary', '0')

// 				if (id === 0 && a === 1) {
// 					el.setAttribute('data-quantity', 1)
// 					el.querySelector('.Counter__input').value = 1
// 					el.setAttribute('data-product-summary', (el.querySelector('.Product-description__molding-item-price-text').textContent * el.querySelector('.Counter__input').value) / 1)
// 					el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary') / 1
// 				} else {
// 					el.setAttribute('data-quantity', 0)
// 					el.querySelector('.Counter__input').value = 0
// 					el.querySelector('.Product-description__molding-item-price-text-total').textContent = 0
// 				}

// 				listItem.forEach(item => {
// 					storage += item.getAttribute('data-product-summary') / 1
// 				})
// 				firstListItems.forEach(item => {
// 					storage1 += item.getAttribute('data-quantity') / 1
// 				})
// 				counterCont.querySelector('.Counter__input').value = storage1
// 				finalPrice.textContent = storage
// 				document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
// 			}

// 			buttonDec.onclick = () => {
// 				let storage = 0
// 				let storage1 = 0
// 				if (el.querySelector('.Counter__input').value <= 0) {
// 					el.querySelector('.Counter__input').value = 0
// 				} else {
// 					el.querySelector('.Counter__input').value--
// 					el.classList.remove('Product-description__molding-item--disabled')
// 					el.setAttribute('data-product-summary', (el.querySelector('.Product-description__molding-item-price-text').textContent * el.querySelector('.Counter__input').value) / 1)
// 					el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')
// 					el.setAttribute('data-quantity', el.querySelector('.Counter__input').value)
// 					listItem.forEach(item => {
// 						storage += item.getAttribute('data-product-summary') / 1
// 					})
// 					firstListItems.forEach(item => {
// 						storage1 += item.getAttribute('data-quantity') / 1
// 					})
// 					counterCont.querySelector('.Counter__input').value = storage1
// 					finalPrice.textContent = storage
// 					document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
// 				}
// 				if ((el.querySelector('.Counter__input').value / 1) === 0) {
// 					el.classList.add('Product-description__molding-item--disabled')
// 					el.setAttribute('data-selected', false)
// 					el.querySelector('.Checkbox__input').removeAttribute('checked')
// 				} else {
// 					el.classList.remove('Product-description__molding-item--disabled')
// 					el.setAttribute('data-selected', true)
// 					el.querySelector('.Checkbox__input').setAttribute('checked', '')
// 				}
// 			}

// 			inputField.oninput = () => {
// 				let storage = 0
// 				let storage1 = 0
// 				if (el.querySelector('.Counter__input').value < 0) {
// 					el.querySelector('.Counter__input').value = 0
// 					el.classList.add('Product-description__molding-item--disabled')
// 					el.setAttribute('data-selected', false)
// 					el.querySelector('.Checkbox__input').removeAttribute('checked')
					
// 				} else {
// 					el.setAttribute('data-product-summary', (el.querySelector('.Product-description__molding-item-price-text').textContent * el.querySelector('.Counter__input').value) / 1)
// 					el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')
// 					el.setAttribute('data-quantity', el.querySelector('.Counter__input').value)
// 					el.setAttribute('data-selected', true)
// 					listItem.forEach(item => {
// 						storage += item.getAttribute('data-product-summary') / 1
// 					})
// 					firstListItems.forEach(item => {
// 						storage1 += item.getAttribute('data-quantity') / 1
// 					})
// 					counterCont.querySelector('.Counter__input').value = storage1
// 					finalPrice.textContent = storage
// 					document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
// 					el.classList.remove('Product-description__molding-item--disabled')
// 					el.querySelector('.Checkbox__input').setAttribute('checked', '')
// 				}
// 			}

// 			buttonInc.onclick = () => {
// 				let storage = 0
// 				let storage1 = 0
// 				el.querySelector('.Counter__input').value++
// 				el.setAttribute('data-product-summary', (el.querySelector('.Product-description__molding-item-price-text').textContent * el.querySelector('.Counter__input').value) / 1)
// 				el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')
// 				el.setAttribute('data-quantity', el.querySelector('.Counter__input').value)
// 				listItem.forEach(item => {
// 					storage += item.getAttribute('data-product-summary') / 1
// 				})
// 				firstListItems.forEach(item => {
// 					storage1 += item.getAttribute('data-quantity') / 1
// 				})
// 				counterCont.querySelector('.Counter__input').value = storage1
// 				finalPrice.textContent = storage
// 				document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
// 				if (el.querySelector('.Counter__input').value > 0) {
// 					el.querySelector('.Checkbox__input').setAttribute('checked', '')
// 					el.setAttribute('data-selected', true)
// 					el.classList.remove('Product-description__molding-item--disabled')
// 				}
// 			}

// 			el.setAttribute('data-price', el.querySelector('.Product-description__molding-item-price-text').textContent)
// 			el.setAttribute('data-quantity', el.querySelector('.Counter__input').value)
// 			el.setAttribute('data-product-summary', el.querySelector('.Product-description__molding-item-price-text').textContent * el.querySelector('.Counter__input').value)

// 			el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')

// 			el.setAttribute('data-selected', el.querySelector('.Checkbox__input').checked)

// 			el.querySelector('.Checkbox__label').addEventListener('click', () => {
// 				el.setAttribute('data-selected', el.querySelector('.Checkbox__input').checked)
// 			})
// 		})
// 		if (a === 1) {
// 			listItem[0].querySelector('.Checkbox__inner-text').dispatchEvent(new Event('click'))
// 			listItem[0].querySelector('.Checkbox__input').setAttribute('checked', '')
// 			listItem[0].setAttribute('data-selected', true)
// 		}
// 		a++
// 	}
// 	if (document.querySelectorAll('.timetable') != null) {
// 		let list = document.querySelectorAll('.timetable')
// 		list.forEach(el => {
// 			list.forEach(item => (item.querySelector('.timetable__item').style.display = 'none'))
// 			el.addEventListener('click', () => {
// 				el.querySelector('.timetable__item').style.display === 'block' ? (el.querySelector('.timetable__item').style.display = 'none') : (el.querySelector('.timetable__item').style.display = 'block')
// 			})
// 		})
// 	}

// 	if (document.querySelectorAll('.inner__input') != null) {
// 		let img = document.querySelectorAll('.inner__input')
// 		img.forEach(el => {
// 			el.addEventListener('change', () => {
// 				let fileReader = new FileReader()
// 				fileReader.onload = () => {
// 					document.querySelector('.img-area').setAttribute('src', fileReader.result)
// 					document.querySelector('.mg-add-logo__icon').style.opacity = '1'
// 					document.querySelector('.mg-add-logo__text').style.opacity = '1'
// 				}
// 				fileReader.readAsDataURL(el.files[0])
// 			})
// 		})
// 	}
// }
// function openP() {
// 	if (document.querySelector('a[href="#popup-check-create"]') != null) {
// 		let openButton = document.querySelector('a[href="#popup-check-create"]')
// 		openButton.addEventListener('click', () => {
// 			document
// 				.querySelector('#popup-check-create')
// 				.querySelector('.fancybox-close-small')
// 				.addEventListener('click', () => {
// 					document.querySelectorAll('.fancybox-is-open').forEach(el => {
// 						el.classList.add('fancybox-is-close')
// 						el.classList.remove('fancybox-is-open')
// 					})
// 				})
// 			newCheck()
// 		})
// 	}
// }

// var counter = 1;
// function newCheck() {
// 	if (document.querySelector('.popup-check-create') != null) {
// 		// Popup window
// 		let mainEl = document.querySelector('.popup-check-create')
// 		// Form inputs and etc...
// 		let blockPag = mainEl.querySelector('.popup-check-create__form-list')
// 		let inputs = mainEl.querySelectorAll('.Input__inp')
// 		// Check variablies
// 		let parentElPopup = document.querySelector('.popup-check-preview')
// 		let openButton = document.querySelector('a[href="#popup-check-create"]')

// 		let promotionalItem = document.querySelector('input[placeholder="Акционный товар... "]')
// 		let parentElem = promotionalItem.closest('.Input__label')
// 		let checkboxProm = parentElem.querySelector('.mg-checkbox__input')


// 		window.onclick = (e) => {
// 			if (e.target === checkboxProm) {
// 				checkboxProm.toggleAttribute('checked')
// 				if (checkboxProm.hasAttribute('checked')) {
// 					promotionalItem.removeAttribute('disabled')
// 				} else {
// 					promotionalItem.setAttribute('disabled', '')
// 				}
// 			}
// 		}

// 		document.querySelector('.save-pdf').addEventListener('click', () => {
// 			blockPag.querySelectorAll('.pagonaj-item').forEach(el => {
// 				// Events
// 				inputs.forEach((el, id) => {
// 					parentElPopup.querySelectorAll('.name-of').forEach(item => {
// 						inputs.forEach(el => {
// 							if (el.classList.contains('name-of')) {
// 								item.textContent = el.value
// 							}
// 						})
// 					})
// 					parentElPopup.querySelectorAll('.desc-of').forEach(() => {
// 						if (el.classList.contains('desc-of')) {
// 							parentElPopup.querySelectorAll('.desc-of')[id - 2].textContent = el.value
// 						}
// 					})
// 				})
// 				let pagIt = blockPag.querySelectorAll('.pagonaj-item')
// 				parentElPopup.querySelectorAll('.check__detail-price__item').forEach((item, index) => {
// 					try {
// 						if (pagIt[index].querySelector('.mg-checkbox__input').hasAttribute('checked')) {
// 							item.querySelector('.detail-name-of').textContent = el.querySelector('.mg-avatar__link').textContent
// 							item.style.display = 'flex'
// 						}
// 					} catch (e) { }
// 				})
// 			})
// 			const element = document.querySelector('.popup-check-preview__wrapper')
// 			html2pdf().from(element).save()
// 		})

// 		document.querySelector('a[href="#popup-check-preview"]').addEventListener('click', () => {

// 			document.querySelector('.fancybox-close-small').addEventListener('click', () => {
// 				document.getElementById('popup-check-preview').style.display = 'none'
// 				counter++
// 				openButton.dispatchEvent(new Event('click'))
// 			})
// 			blockPag.querySelectorAll('.pagonaj-item').forEach(el => {
// 				// Events
// 				inputs.forEach((el, id) => {
// 					parentElPopup.querySelectorAll('.name-of').forEach(item => {
// 						inputs.forEach(el => {
// 							if (el.classList.contains('name-of')) {
// 								item.textContent = el.value
// 								let newPrice = document.querySelector('.total-price-of--promotion-item')
// 								if (checkboxProm.hasAttribute('checked')) {
// 									newPrice.removeAttribute('style')
// 									newPrice.textContent = promotionalItem.value + "₽"
// 									document.querySelector('.total-price-of').setAttribute('style', 'color: gray; text-decoration: line-through; font-size: 16px;')
// 								} else {
// 									newPrice.setAttribute('style', 'display: none;')
// 									document.querySelector('.total-price-of').removeAttribute('style')
// 								}
// 							}
// 						})
// 					})
// 					parentElPopup.querySelectorAll('.desc-of').forEach(() => {
// 						if (el.classList.contains('desc-of')) {
// 							[...parentElPopup.querySelectorAll('.desc-of')][id - 2].textContent = el.value
// 						}
// 					})
// 				})
// 				parentElPopup.querySelectorAll('.check__detail-price__item').forEach((item, index) => {
// 					if ([...blockPag.querySelectorAll('.pagonaj-item')][index].querySelector('.mg-checkbox__input').hasAttribute('checked')) {
// 						item.querySelector('.detail-name-of').textContent = blockPag.querySelectorAll('.pagonaj-item')[index].querySelector('.mg-avatar__link').textContent
// 						item.style.display = 'flex'
// 					} else {
// 						item.style.display = 'none'
// 					}
// 				})
// 			})
// 			blockPag.querySelectorAll('.pagonaj-item').forEach((el, index) => {
// 				if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
// 					let totalprice = 0
// 					el.setAttribute('data-price-of', el.getAttribute('data-price') * priceCounter + el.getAttribute('data-price-of') / 1)
// 					el.querySelector('.Counter__input').value = el.getAttribute('data-price-of')
// 					parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + '₽'
// 					blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
// 						if (el.closest('li').classList.contains('checked-item')) {
// 							totalprice += el.value / 1
// 						}
// 					})
// 					blockPag.setAttribute('total-price-of', totalprice)
// 					parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + '₽'
// 					priceCounter++
// 				}
// 			})
// 		})

// 		blockPag.querySelectorAll('.pagonaj-item').forEach((el, index) => {
// 			let priceCounter = 1
// 			el.querySelector('.Counter__input').value = el.getAttribute('data-price-of')

// 			if (counter === 1) {
// 				el.querySelector('button[data-decrement]').addEventListener('click', () => {
// 					if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
// 						if (el.getAttribute('data-price-of') <= 0) {
// 							el.setAttribute('data-price-of', 0)
// 						} else {
// 							let totalprice = 0
// 							el.setAttribute('data-price-of', el.getAttribute('data-price-of') - el.getAttribute('data-price'))
// 							el.querySelector('.Counter__input').value = el.getAttribute('data-price-of')
// 							parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + '₽'
// 							blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
// 								if (el.closest('li').classList.contains('checked-item')) {
// 									totalprice += el.value / 1
// 								}
// 							})
// 							blockPag.setAttribute('total-price-of', totalprice)
// 							parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + '₽'
// 							priceCounter--
// 						}
// 					}
// 				})
// 				el.querySelector('button[data-increment]').addEventListener('click', () => {
// 					if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
// 						let totalprice = 0
// 						el.setAttribute('data-price-of', (el.getAttribute('data-price-of') / 1 + el.getAttribute('data-price') / 1))
// 						el.querySelector('.Counter__input').value = el.getAttribute('data-price-of')
// 						parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + '₽'
// 						blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
// 							if (el.closest('li').classList.contains('checked-item')) {
// 								totalprice += el.value / 1
// 							}
// 						})
// 						blockPag.setAttribute('total-price-of', totalprice)
// 						parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + '₽'
// 						priceCounter++
// 					}
// 				})

// 				el.querySelector('.Counter__input').addEventListener('change', () => {
// 					if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
// 						let totalprice = 0
// 						el.setAttribute('data-price-of', el.querySelector('.Counter__input').value)
// 						parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + '₽'
// 						blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
// 							if (el.closest('li').classList.contains('checked-item')) {
// 								totalprice += el.value / 1
// 							}
// 						})
// 						blockPag.setAttribute('total-price-of', totalprice)
// 						parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + '₽'
// 					}
// 				})

// 				el.querySelector('.mg-checkbox__input').addEventListener('click', () => {
// 					if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
// 						el.querySelector('.mg-checkbox__input').removeAttribute('checked')
// 						el.classList.remove('checked-item')
// 						el.querySelector('.Counter__input').setAttribute('disabled', '')

// 					} else {
// 						el.querySelector('.mg-checkbox__input').setAttribute('checked', '')
// 						el.querySelector('.Counter__input').removeAttribute('disabled')
// 						el.classList.add('checked-item')
// 					}

// 					let totalprice = 0
// 					parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + '₽'
// 					blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
// 						if (el.closest('li').classList.contains('checked-item')) {
// 							totalprice += el.value / 1
// 						}
// 					})
// 					blockPag.setAttribute('total-price-of', totalprice)
// 					parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + '₽'
// 					priceCounter++

// 					blockPag.querySelectorAll('.pagonaj-item').forEach(el => {
// 						// Events

// 						parentElPopup.querySelectorAll('.check__detail-price__item').forEach((item, index) => {
// 							if ([...blockPag.querySelectorAll('.pagonaj-item')][index].querySelector('.mg-checkbox__input').hasAttribute('checked')) {
// 								item.querySelector('.detail-name-of').textContent = el.querySelector('.mg-avatar__link').textContent
// 								item.style.display = 'flex'
// 							}
// 						})
// 					})
// 				})
// 			}
// 		})
// 		document.querySelector('.print-pdf').addEventListener('click', () => {
// 			let check = document.querySelector('.popup-check-preview__wrapper')
// 			let divContents = $(check).html()
// 			let printWindow = window.open('', '')
// 			printWindow.document.write('<html><head><title>Новый чек</title><link rel="stylesheet" href="/local/templates/tandoor/app/css/main.min.css" /><link rel="stylesheet" href="/local/templates/tandoor/app/css/libs-styles.min.css" />')
// 			// printWindow.document.write('<html><head><title>Новый чек</title><link rel="stylesheet" href="css/main.min.css" /><link rel="stylesheet" href="css/libs-styles.min.css" />') // local version
// 			printWindow.document.write('</head><body>')
// 			printWindow.document.write(divContents)
// 			printWindow.document.write(
// 				'<button class="test" onclick="window.print()" style="border: none; bacground: #fff;"></button><script>setTimeout(() => {document.querySelector(`.test`).dispatchEvent(new Event(`click`))}, 1000)</script></body></html>',
// 			)
// 			printWindow.document.close()
// 		})
// 	}
// }